import React from 'react';

import { Link } from 'expo-router';
import { Text, View } from 'react-native';

import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

export const DeliveryTerms = () => {
  return (
    <View style={{ alignItems: 'center', justifyContent: 'center', paddingHorizontal: 16 }}>
      <Text style={{ textAlign: 'center', lineHeight: 20 }}>
        {t('deliveryTermsPrefix')}
        <Link href={routes.deliveryTerms}>
          <Text style={{ textDecorationLine: 'underline', color: '#000' }}>
            {t('clickHereForDetails')}
          </Text>
        </Link>
      </Text>
    </View>
  );
};
